export const SET_ECHEANCIERS = 'SET_ECHEANCIERS';
export const SET_TOTAL_ECHEANCIERS = 'SET_TOTAL_ECHEANCIERS';
export const SET_TOTAL_ECHEANCIERS_BEFORE_NOW = 'SET_TOTAL_ECHEANCIERS_BEFORE_NOW';
export const SET_ECHEANCIERS_LASTDATAFROMLOAD = 'SET_ECHEANCIERS_LASTDATAFROMLOAD';
export const SET_ECHEANCIER = 'SET_ECHEANCIER';
export const SET_CRITERE = 'SET_CRITERE';
export const SET_ORDERBY = 'SET_ORDERBY';
export const SET_INDICATEUR = 'SET_INDICATEUR';
export const SET_DATE_SAVE = 'SET_DATE_SAVE';
